module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-configuration row column"
  }, [_c('accordion', _vm._l((_vm.conf), function(section, i) {
    return _c('accordion-item', {
      attrs: {
        "title": i
      }
    }, _vm._l((section), function(c, ic) {
      return _c('configuration-item', {
        attrs: {
          "item": c,
          "itemKey": ic
        },
        on: {
          "updateItem": _vm.updateItem
        }
      })
    }), 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16aea539!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/Configuration.vue
// module id = 2294
// module chunks = 1